"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importStar(require("styled-components"));
var Polished_1 = require("../utils/Polished");
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var SvgCheck_1 = __importDefault(require("../Icon/SvgCheck"));
var SvgMinus_1 = __importDefault(require("../Icon/SvgMinus"));
var Box_1 = __importDefault(require("../Box"));
var Typography_1 = __importDefault(require("../Typography"));
var StyledFakeCheck = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-shrink: 0;\n  display: block;\n  box-sizing: border-box;\n  height: ", ";\n  width: ", ";\n  overflow: hidden;\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-radius: ", ";\n  background-color: transparent;\n\n  & > svg {\n    margin-top: ", ";\n    margin-left: ", ";\n  }\n\n  ._ndsCheck--checked & {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  ._ndsCheck--checked._ndsCheck--disabled & {\n    background-color: ", ";\n  }\n\n  ._ndsCheck--disabled & {\n    border-color: ", ";\n    background-color: transparent;\n  }\n\n  will-change: border-color, background-color, box-shadow;\n  transition: border-color 0.3s, background-color 0.3s, box-shadow 0.3s;\n"], ["\n  flex-shrink: 0;\n  display: block;\n  box-sizing: border-box;\n  height: ", ";\n  width: ", ";\n  overflow: hidden;\n  border-width: ",
    ";\n  border-style: solid;\n  border-color: ",
    ";\n  border-radius: ",
    ";\n  background-color: transparent;\n\n  & > svg {\n    margin-top: ", ";\n    margin-left: ", ";\n  }\n\n  ._ndsCheck--checked & {\n    border-color: ",
    ";\n    background-color: ",
    ";\n  }\n\n  ._ndsCheck--checked._ndsCheck--disabled & {\n    background-color: ",
    ";\n  }\n\n  ._ndsCheck--disabled & {\n    border-color: ",
    ";\n    background-color: transparent;\n  }\n\n  will-change: border-color, background-color, box-shadow;\n  transition: border-color 0.3s, background-color 0.3s, box-shadow 0.3s;\n"])), function (props) { return props.theme.SizeHeightCheckboxBase; }, function (props) { return props.theme.SizeWidthCheckboxBase; }, function (props) {
    return props.theme.SizeBorderWidthCheckboxBase;
}, function (props) {
    return props.theme.ColorBorderCheckboxBase;
}, function (props) {
    return props.theme.SizeBorderRadiusCheckboxBase;
}, Polished_1.rem('-3.5px'), Polished_1.rem('-3px'), function (props) {
    return props.theme.ColorBorderCheckboxChecked;
}, function (props) {
    return props.theme.ColorBackgroundCheckboxChecked;
}, function (props) {
    return props.theme.ColorBackgroundCheckboxCheckedDisabled;
}, function (props) {
    return props.theme.ColorBorderCheckboxDisabled;
});
var RealHiddenCheck = styled_components_1.default.input.attrs(function (props) { return (__assign({ type: 'checkbox' }, props)); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var WrapperLabel = styled_components_1.default.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  user-select: none;\n\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n\n  & > span {\n    will-change: color;\n    transition: color 0.3s;\n  }\n\n  &._ndsCheck--disabled > span {\n    color: ", ";\n  }\n\n  :hover {\n    cursor: pointer;\n  }\n\n  &._ndsCheck--disabled:hover {\n    cursor: not-allowed;\n  }\n\n  ._ndsCheck__styled {\n    position: relative;\n    > svg {\n      position: absolute;\n    }\n  }\n\n  & input:focus + ._ndsCheck__styled,\n  :hover ._ndsCheck__styled {\n    border-color: ", ";\n    box-shadow: ", "\n      ", ";\n    background-color: transparent;\n  }\n\n  &._ndsCheck--checked input:focus + ._ndsCheck__styled,\n  &._ndsCheck--checked:hover ._ndsCheck__styled {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  &._ndsCheck--checked._ndsCheck--disabled input:focus + ._ndsCheck__styled,\n  &._ndsCheck--checked._ndsCheck--disabled:hover ._ndsCheck__styled {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  &._ndsCheck--disabled:hover ._ndsCheck__styled {\n    border-color: ", ";\n    box-shadow: none;\n  }\n"], ["\n  user-select: none;\n\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n\n  & > span {\n    will-change: color;\n    transition: color 0.3s;\n  }\n\n  &._ndsCheck--disabled > span {\n    color: ", ";\n  }\n\n  :hover {\n    cursor: pointer;\n  }\n\n  &._ndsCheck--disabled:hover {\n    cursor: not-allowed;\n  }\n\n  ._ndsCheck__styled {\n    position: relative;\n    > svg {\n      position: absolute;\n    }\n  }\n\n  & input:focus + ._ndsCheck__styled,\n  :hover ._ndsCheck__styled {\n    border-color: ",
    ";\n    box-shadow: ", "\n      ", ";\n    background-color: transparent;\n  }\n\n  &._ndsCheck--checked input:focus + ._ndsCheck__styled,\n  &._ndsCheck--checked:hover ._ndsCheck__styled {\n    border-color: ",
    ";\n    background-color: ",
    ";\n  }\n\n  &._ndsCheck--checked._ndsCheck--disabled input:focus + ._ndsCheck__styled,\n  &._ndsCheck--checked._ndsCheck--disabled:hover ._ndsCheck__styled {\n    border-color: ",
    ";\n    background-color: ",
    ";\n  }\n\n  &._ndsCheck--disabled:hover ._ndsCheck__styled {\n    border-color: ",
    ";\n    box-shadow: none;\n  }\n"])), Polished_1.rem('20px'), function (props) { return props.theme.ColorFontCheckboxDisabled; }, function (props) {
    return props.theme.ColorBorderCheckboxHover;
}, function (props) { return props.theme.SizeShadowCheckbox; }, function (props) { return props.theme.ColorShadowCheckboxHover; }, function (props) {
    return props.theme.ColorBorderCheckboxCheckedHover;
}, function (props) {
    return props.theme.ColorBackgroundCheckboxCheckedHover;
}, function (props) {
    return props.theme.ColorBorderCheckboxDisabled;
}, function (props) {
    return props.theme.ColorBackgroundCheckboxCheckedDisabled;
}, function (props) {
    return props.theme.ColorBorderCheckboxDisabledHover;
});
var Checkbox = function (props) {
    var disabled = props.disabled, checkedProp = props.checked, indeterminate = props.indeterminate, label = props.label, onChange = props.onChange, forwardedRef = props.forwardedRef, className = props.className, id = props.id, name = props.name, value = props.value, theme = props.theme, rest = __rest(props, ["disabled", "checked", "indeterminate", "label", "onChange", "forwardedRef", "className", "id", "name", "value", "theme"]);
    var _a = react_1.default.useState(Boolean(checkedProp)), checkedState = _a[0], setCheckedState = _a[1];
    var isControlled = react_1.default.useRef(checkedProp !== undefined).current;
    var handleCheckboxChange = react_1.default.useCallback(function (event) {
        var target = event.target;
        if (!isControlled && !disabled) {
            setCheckedState(target.checked);
        }
        if (onChange && !disabled) {
            onChange(event, target.checked);
        }
    }, [onChange, disabled, isControlled]);
    var handleKeyPress = react_1.default.useCallback(function (event) {
        event.target.click();
    }, []);
    var checked = isControlled ? checkedProp : checkedState;
    var renderIcon = null;
    if (checked) {
        var IconComp = indeterminate ? SvgMinus_1.default : SvgCheck_1.default;
        renderIcon = react_1.default.createElement(IconComp, { color: theme.ColorIconCheckboxBase, size: "m" });
    }
    var labelComp = react_1.default.useMemo(function () {
        if (!label) {
            return null;
        }
        if (typeof label === 'string') {
            return (react_1.default.createElement(Box_1.default, { ml: 0.75 },
                react_1.default.createElement(Typography_1.default, { variant: "body3" }, label)));
        }
        return react_1.default.createElement(Box_1.default, { ml: 0.75 }, label);
    }, [label]);
    return (react_1.default.createElement(WrapperLabel, { onKeyPress: handleKeyPress, className: clsx_1.default({ '_ndsCheck--checked': checked }, { '_ndsCheck--disabled': disabled }, className) },
        react_1.default.createElement(RealHiddenCheck, __assign({ ref: forwardedRef, checked: checked, onChange: handleCheckboxChange, id: id, name: name, value: value }, rest)),
        react_1.default.createElement(StyledFakeCheck, { className: "_ndsCheck__styled" }, renderIcon),
        labelComp));
};
exports.CheckboxRootComp = Checkbox;
Checkbox.propTypes = {
    checked: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    indeterminate: prop_types_1.default.bool,
    label: prop_types_1.default.node,
    onChange: prop_types_1.default.func,
    forwardedRef: prop_types_1.default.any,
    id: prop_types_1.default.string,
    name: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    className: prop_types_1.default.string,
    theme: prop_types_1.default.any
};
Checkbox.defaultProps = {
    checked: undefined,
    disabled: false,
    indeterminate: false,
    label: null,
    onChange: null,
    forwardedRef: null,
    id: undefined,
    name: undefined,
    value: undefined,
    className: undefined,
    theme: {}
};
var CheckBoxWithTheme = styled_components_1.withTheme(Checkbox);
exports.default = reactHelpers_1.withForwardedRef(CheckBoxWithTheme);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Checkbox.js.map